import { useRef, useEffect } from 'react';
import { motion, useAnimation, useInView } from 'framer-motion';
import { BENEFITES } from '../../../assets/utils/constants';
import './SellBenefits.css';

const listItemsVariants = {
  hidden: { opacity: 0, y: -20 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      duration: 2,
      delay: i * 0.4,
      ease: 'easeInOut',
      type: 'spring',
      bounce: 0.4,
    },
  }),
};

function SellBenefits() {
  const itemsRef = useRef(null);
  const itemsControls = useAnimation();
  const itemsInView = useInView(itemsRef, { once: true, amount: 0.5 });

  useEffect(() => {
    itemsInView
      ? itemsControls.start('visible')
      : itemsControls.start('hidden');
  }, [itemsInView, itemsControls]);

  return (
    <ul className="sell-benefits" ref={itemsRef}>
      {BENEFITES.map((item, i) => (
        <motion.li
          className="sell-benefits__item"
          key={item}
          variants={listItemsVariants}
          initial="hidden"
          animate={itemsControls}
          custom={i}
        >
          <span className="sell-benefits__index">{i + 1}</span>
          <p
            className="sell-benefits__text"
            dangerouslySetInnerHTML={{ __html: item }}
          />
        </motion.li>
      ))}
    </ul>
  );
}

export default SellBenefits;
